import { post, postKeepAlive } from '../../api/api';
import { SessionLoginStartPayload, SessionLoginClosePayload } from '../modelos/ISessionLogin';

export async function startSessionLogin(payload: SessionLoginStartPayload) {
  try {
    return await post('/session-login/start', payload);
  } catch (e) {
    console.error('Erro ao iniciar sessão', e);
    throw e;
  }
}

export async function closeSessionLogin(payload: SessionLoginClosePayload) {
  try {
    return await postKeepAlive('/session-login/close', payload);
  } catch (e) {
    console.error('Erro ao fechar sessão', e);
    throw e;
  }
}
